import { AuthorizationModel } from "./../../authentication/models/authorization-model";
import { IDocumentModel } from "./../interfaces/document-model";
import { AppSettings } from "../../app-settings";
import { BaseDocumentModel } from "../../desktop/models/base-document";
import { backboneCollectionProperties } from "../../decorators/backbone-properties";

@backboneCollectionProperties({
    model: AuthorizationModel
})
export class DocumentCollection extends Backbone.Collection<IDocumentModel> {
    constructor(options?) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/collections/documents.ts